import { schedulerTypes } from '@/utils/hooks/context/toast/types';

import { SCHEDULER } from '@/routes/privateRoutes';

type NotificationUrlParams = {
    postId: number;
    socialProfileId?: number;
};

class SchedulerNotificationService {
    /**
     * Génère l'URL pour une notification de type "master updated"
     */
    private generateMasterUpdatedUrl({ postId, socialProfileId }: NotificationUrlParams): string {
        const baseUrl = `${SCHEDULER}?post_id=${postId}`;
        return socialProfileId
            ? `${baseUrl}&master_display_profile_id=${socialProfileId}`
            : baseUrl;
    }

    /**
     * Génère l'URL pour une notification de type "post updated"
     */
    private generatePostUpdatedUrl({ postId, socialProfileId }: NotificationUrlParams): string {
        const baseUrl = `${SCHEDULER}?post_id=${postId}`;
        return socialProfileId ? `${baseUrl}&social_profile_id=${socialProfileId}` : baseUrl;
    }

    /**
     * Génère l'URL pour une notification de type "preview post"
     */
    private generatePreviewPostUrl({ postId, socialProfileId }: NotificationUrlParams): string {
        const baseUrl = `${SCHEDULER}?preview_post_id=${postId}`;
        return socialProfileId ? `${baseUrl}&social_profile_id=${socialProfileId}` : baseUrl;
    }

    /**
     * Détermine l'URL appropriée selon le type de notification
     */
    getNotificationUrl(notificationType: string, params: NotificationUrlParams): string {
        switch (notificationType) {
            case schedulerTypes.POST_UPDATED:
                return this.generateMasterUpdatedUrl(params);

            case schedulerTypes.POST_APPROVED_ACTION_REQUIRED:
            case schedulerTypes.POST_REJECTED_ACTION_REQUIRED:
            case schedulerTypes.MULTIPOST_APPROVED_ACTION_REQUIRED:
                return this.generatePostUpdatedUrl(params);

            default:
                return this.generatePreviewPostUrl(params);
        }
    }
}

const schedulerNotificationService = new SchedulerNotificationService();
export { schedulerNotificationService as SchedulerNotificationService };
